import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarEmpty from './components/NavbarEmpty';
import PageCard from './components/PageCard';
import Footer from './components/Footer';
import Pagination10 from './components/Pagination10';
import usePagination10 from './components/hooks/usePagination10';
import DefaultModal from './components/modals/DefaultModal';
import { logout } from './api/logout';

function SelecionaEntidade() {
  const [relAssociacaoUsuario, setRelAssociacaoUsuario] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [modalData, setModalData] = useState({ show: false, type: '', message: '' });
  const navigate = useNavigate();

  const showDefaultModal = (type, message) => setModalData({ show: true, type, message });
  const closeDefaultModal = () => setModalData(prev => ({ ...prev, show: false }));

  useEffect(() => {
    const storedOptions = localStorage.getItem('relAssociacaoUsuario');
    if (storedOptions) {
      try {
        const parsedOptions = JSON.parse(storedOptions);
        setRelAssociacaoUsuario(parsedOptions);
        if (parsedOptions.length === 1) {
          const singleOption = parsedOptions[0];
          localStorage.setItem('associacao', JSON.stringify(singleOption.associacao));
          localStorage.setItem('cnpj', singleOption.associacao.cnpj);
          localStorage.setItem('usuarioBind', JSON.stringify(singleOption));
          navigate('/home');
        }
      } catch (error) {
        console.error('Erro ao parsear os dados do localStorage:', error);
      }
    }
  }, [navigate]);

  const normalizeString = str =>
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const associacoesFiltradas = Array.isArray(relAssociacaoUsuario)
    ? relAssociacaoUsuario.filter(option => {
        const filtroNormalizado = normalizeString(filtro);
        const nome = normalizeString(option.associacao.nome);
        const cidade = normalizeString(option.associacao.logrCidade || '');
        return nome.includes(filtroNormalizado) || cidade.includes(filtroNormalizado);
      })
    : [];

  const totalItems = associacoesFiltradas.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedAssociacoes = associacoesFiltradas.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const handleSelect = option => {
    localStorage.setItem('associacao', JSON.stringify(option.associacao));
    localStorage.setItem('cnpj', option.associacao.cnpj);
    localStorage.setItem('usuarioBind', JSON.stringify(option));
    navigate('/home');
  };

  const handleLogout = () => {
    const token = localStorage.getItem('token');
    if (token) { logout(token).catch(() => {}); }
    localStorage.clear();
    try { sessionStorage.setItem('justLoggedOut', 'true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
    navigate('/');
  };

  const formatCnpj = cnpj => {
    if (!cnpj || cnpj.length !== 14) return cnpj;
    return `${cnpj.slice(0,2)}.${cnpj.slice(2,5)}.${cnpj.slice(5,8)}/${cnpj.slice(8,12)}-${cnpj.slice(12)}`;
  };

  return (
    <div
      className="full-screen-div"
      style={{
        backgroundImage: `url('/assets/desktop.png')`,
        padding: '0 20px',
        paddingTop: '77px',
        paddingBottom: '60px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <NavbarEmpty />
      <PageCard
        embedded
        title="Seleção de Associação"
        icon="bi-building-check"
        scrollable={false}
        onClose={handleLogout}
        footer={totalItems > 0 ? <Pagination10 {...setPagination} /> : null}
        style={{ flex: 1 }}
      >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="d-flex flex-wrap gap-2 mb-2 p-2 bg-light rounded border align-items-center">
          <span className="text-muted small">
            <strong>{totalItems}</strong> entidade{totalItems !== 1 ? 's' : ''} disponíve{totalItems !== 1 ? 'is' : 'l'}
          </span>
          <div className="ms-auto d-flex align-items-center gap-2">
            <div className="input-group" style={{ maxWidth: 300, height: 31 }}>
              <span className="input-group-text bg-white border-end-0 px-2" style={{ height: 31 }}>
                <i className="bi bi-search text-muted" style={{ fontSize: 13 }} />
              </span>
              <input
                type="text"
                className="form-control form-control-sm border-start-0"
                style={{ height: 31, fontSize: 13 }}
                placeholder="Buscar por nome ou cidade..."
                value={filtro}
                onChange={e => setFiltro(e.target.value)}
              />
              {filtro && (
                <button
                  className="btn btn-outline-secondary btn-sm border-start-0 d-flex align-items-center px-2"
                  style={{ height: 31 }}
                  onClick={() => setFiltro('')}
                  title="Limpar pesquisa"
                  tabIndex={-1}
                >
                  <i className="bi bi-x-lg" style={{ fontSize: 11 }} />
                </button>
              )}
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-danger btn-sm d-inline-flex align-items-center"
              title="Sair do sistema"
            >
              <i className="bi bi-box-arrow-right me-1" />
              Sair
            </button>
          </div>
        </div>

        <div
          className="table-responsive-sm shadow-sm mb-0 small"
          style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}
        >
          <table className="table table-hover table-striped table-sm">
            <thead className="table-secondary sticky-top bg-light">
              <tr>
                <th scope="col" className="align-middle">CNPJ</th>
                <th scope="col" className="align-middle">Nome da Associação</th>
                <th scope="col" className="align-middle d-none d-md-table-cell">Nome Fantasia</th>
                <th scope="col" className="align-middle d-none d-md-table-cell">Cidade</th>
                <th scope="col" className="align-middle">UF</th>
                <th scope="col" className="align-middle text-center">Acesso</th>
              </tr>
            </thead>
            <tbody>
              {selectedAssociacoes.map(option => (
                <tr key={option.associacao.cnpj}>
                  <td className="text-muted">{formatCnpj(option.associacao.cnpj)}</td>
                  <td>{option.associacao.nome}</td>
                  <td className="d-none d-md-table-cell">{option.associacao.fantasia || '—'}</td>
                  <td className="d-none d-md-table-cell">{option.associacao.logrCidade || '—'}</td>
                  <td>{option.associacao.logrUf || '—'}</td>
                  <td className="text-center">
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => handleSelect(option)}
                      title="Acessar Associação"
                    >
                      <i className="bi bi-box-arrow-in-right me-1" />
                      Acessar
                    </button>
                  </td>
                </tr>
              ))}
              {selectedAssociacoes.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">
                    Nenhuma associação encontrada.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
      </PageCard>
      <Footer />
    </div>
  );
}

export default SelecionaEntidade;
